<template>
  <div id="one-click-order">
    <div id="sort-by" style="background: #f3f4f5">
      <div class="sort">
        通用名：
        <div class="select-text">
          <b-dropdown :text="disSerachName" variant="outline-danger" class="m-1">
            <b-dropdown-item
              v-for="(name,index) in names"
              :key="index"
              @click="choose('name',name)"
            >{{ name.value }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <span class="export-quatation" @click="exportResult">导出结果</span>
    </div>
    <div id="sort-by">
      <div class="sort">
        排序依据：
        <div class="select-text">
          <b-dropdown :text="sortBy.sorttext" variant="outline-danger" class="m-1">
            <b-dropdown-item
              v-for="(sort,index) in sortText"
              :key="index"
              @click="choose('sort',sort)"
            >{{ sort.text }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div id="content">
      <b-table :items="itemList" :fields="fields">
        <template v-slot:cell(image)="data">
          <img id="img" :src="data.value" alt>
        </template>
        <template v-slot:cell(num)="data">
          <span class="cutdown" @click="cutdown(data.index)">-</span>
          <input v-model="data.value" class="num">
          <span class="add" @click="add(data.index)">+</span>
        </template>
        <template v-slot:cell(operate)="data">
          <b-button variant="danger" @click="addToCart(data)">加入</b-button>
        </template>
      </b-table>
    </div>
    <div id="footer">
      <div class="select-page">
        <span class="page-now" style="cursor:pointer" @click="firstPage">首页</span>
        <span class="page-now" style="cursor:pointer" @click="previousPage">上一页</span>
        <span class="page-now" style="cursor:pointer" @click="nextPage">下一页</span>
        <span class="page-now" style="cursor:pointer" @click="lastPage">尾页</span>
        <input v-model="pageInfo.index" class="page-now" style="cursor:pointer" @blur="searchFirst">/
        <span class="page-count">{{ pageInfo.pages }}</span>页
      </div>
      <div class="page-display">
        每页显示
        <input v-model="pageInfo.size" style="cursor:pointer" class="page-now data-now" @blur="searchFirst">条,
        共
        <span class="data-count">{{ pageInfo.count }}</span>条数据
        <span class="fresh" style="cursor:pointer" @click="search">刷新</span>
      </div>
    </div>
  </div>
</template>
<script>
import { ItemService } from '@/service/ItemService'
export default {
  props: {
    quotationid: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      test1: undefined,
      fields: [
        { key: 'image', label: '图片' }, { key: 'generalName', label: '通用名/商品名' },
        { key: 'norm', label: '规格' }, { key: 'manufacturer', label: '生产厂家' },
        { key: 'licenseNumber', label: '批准文号' }, { key: 'shopName', label: '供应商' },
        { key: 'largeScale', label: '大包装' }, { key: 'basicUnit', label: '单位' },
        { key: 'inventory', label: '库存' }, { key: 'expiryTime', label: '有效期至' },
        { key: 'quantity', label: '预定数量' }, { key: 'quotationPrice', label: '单价' },
        { key: 'num', label: '数量' }, { key: 'operate', label: '订购' }
      ],
      loadQuotationid: 0,
      isClick: true,
      check: true,
      disSerachName: '全部',
      serachName: undefined,
      sortBy: { sorttext: '默认', sort: undefined },
      names: [{ key: undefined, value: '全部' }],
      sortText: [{ text: '默认', sort: undefined },
        { text: '供应商', sort: 'shopNamePinyin asc' },
        { text: '批准文号', sort: 'licenseNumberPinyin desc' },
        { text: '库存', sort: 'inventory desc' },
        { text: '通用名', sort: 'generalNamePinyin desc' },
        { text: '销量', sort: 'salesVolume desc' }],
      pageInfo: { count: '', index: 1, pages: '', size: 10 },
      itemList: []
    }
  },
  computed: {
  },
  watch: {
    quotationid: function (newV, oldV) {
      // 观察传入报价单号的变化，用于请求报价单中的商品
      console.log(newV, 'newV+++++++++++++')
      if (newV !== undefined) {
        this.initialData()
        this.searchFirst()
      }
      console.log(oldV, 'oldV+++++++++++++')
    }
  },
  mounted () {
    this.initialData()
    this.searchFirst()
  },
  methods: {
    get (row) {
      console.log(row)
    },
    add (num) {
      this.itemList[num].num++
    },
    exportResult () {
      const data = {
        inquerysheetId: this.quotationid,
        generalName: this.serachName,
        index: this.pageInfo.index,
        size: this.pageInfo.size,
        orderBy: this.sortBy.sort
      }
      const Item = new ItemService(this.$axios)
      Item.exportQuotationResult(data).then((responese) => {
        console.log(responese, 'rspoonse')
      })
    },
    cutdown (num) {
      if (this.itemList[num].num !== 0) {
        this.itemList[num].num--
      }
    },
    addToCart (data) {
      console.log(data, '+++++')
      if (data.item.num !== 0) {
        if (this.$store.getters.getItemById(data.item.id)[0] !== undefined && this.$store.getters.getItemById(data.item.id)[0].num > 0) {
          data.item.num = this.$store.getters.getItemById(data.item.id)[0].num + data.item.num
        }
        const tmpItem = {};
        ({ id: tmpItem.id, num: tmpItem.num, image: tmpItem.image, shopId: tmpItem.shopId, shopName: tmpItem.shopName,
          norm: tmpItem.norm, name: tmpItem.name, manufacturer: tmpItem.manufacture, showPrice: tmpItem.price } = data.item)
        data.item.num = 0
        console.log('tmpItem+++++', tmpItem)
        this.$store.commit('addTocart', tmpItem)
      }
    },
    toast () {
      this.$emit('toast', '添加成功')
    },
    put () {
      console.log(this.$store.getters.cartItems, 'item')
    },
    searchFirst () {
      const data = {
        inquerysheetId: this.quotationid,
        generalName: this.serachName,
        index: this.pageInfo.index,
        size: this.pageInfo.size,
        orderBy: this.sortBy.sort
      }
      var waitLoadItems = new Promise((resolve, reject) => {
        this.loadItems(data, resolve)
        console.log('商品加载完成')
      })
      var waitLoadgeneralName = new Promise((resolve, reject) => {
        this.loadgeneralName(this.quotationid, resolve)
        console.log('通用名')
      })
      Promise.all([waitLoadItems, waitLoadgeneralName]).then(values => {
        this.dealItems(values[0])
        this.dealGeneralName(values[1])
      })
    },
    search () {
      this.itemList = []
      this.pageInfo = { count: '', index: 1, pages: '', size: 10 }
      const data = {
        inquerysheetId: this.quotationid,
        generalName: this.serachName,
        index: this.pageInfo.index,
        size: this.pageInfo.size,
        orderBy: this.sortBy.sort
      }
      var waitLoadItems = new Promise((resolve, reject) => {
        this.loadItems(data, resolve)
        console.log('商品加载完成')
      })

      Promise.all([waitLoadItems]).then(values => {
        this.dealItems(values[0])
      })
    },
    loadgeneralName (quotationid, resolve) {
      var data = { params: { inquerysheetId: quotationid }}
      const Item = new ItemService(this.$axios)
      Item.loadgeneralName(data).then((responese) => {
        console.log(responese, '通用名++++++++++')
        resolve(responese)
      })
    },
    dealGeneralName (data) {
      this.names = [{ key: undefined, value: '全部' }]
      data.content.forEach(name => {
        var obj = {}
        obj.key = name
        obj.value = name
        this.names.push(obj)
      })
    },
    initialData () {
      this.isClick = true
      this.check = true
      this.sortBy = { sorttext: '默认', sort: 'createTime desc' }
      this.pageInfo = { count: '', index: 1, pages: '', size: 10 }
      this.itemList = []
    },
    choose (str, data) {
      console.log(str, data)
      if (str === 'name') {
        this.disSerachName = data.value
        this.serachName = data.key
        this.search()
      } else {
        ({ text: this.sortBy.sorttext, sort: this.sortBy.sort } = data)
        this.search()
      }
    },
    loadItems (data, resolve) {
      const Item = new ItemService(this.$axios)
      Item.loadQuotationItem(data).then((responese) => {
        resolve(responese)
      })
    },
    dealItems (res) {
      this.itemList = []
      const { items = [], pageInfo = {}} = res;
      ({ count: this.pageInfo.count, index: this.pageInfo.index, pages: this.pageInfo.pages, size: this.pageInfo.size } = pageInfo)
      items.forEach(item => {
        item.num = 0
        this.itemList.push(item)
      })
    },
    firstPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index = 1
        this.searchFirst()
      }
    },
    previousPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index -= 1
        this.searchFirst()
      }
    },
    nextPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index += 1
        this.searchFirst()
      }
    },
    lastPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index = this.pageInfo.pages
        this.searchFirst()
      }
    }
  }
}
</script>
<style scoped>
  #one-click-order {
    background-color: #f5f5f5;
    max-width: 1200px;
    text-align: center;
    margin: 0 auto;
    color: #000;
  }
  .select-text {
    display: inline-block;
  }
  .row {
    margin: 0;
    justify-content:space-between;
  }
  .col:first-child {
    padding-left: 0;
    text-align: left;
  }
  .col {
    padding: 0;
    height: 30px;
    text-align: right;
  }
  .m-1 {
    margin: 0 !important;
    width: 220px;
  }
  .btn-outline-danger {
    color: #000;
    border-color: #ccc;
  }
  .btn-outline-danger:focus, .btn-outline-danger.focus {
    box-shadow: 0 !important;
  }
   .dropdown-menu {
    height: 10rem;
    min-width: 15rem;
    overflow: scroll;
  }
  .dropdown-toggle::after {
    position: absolute;
    top: 0.65rem;
    right: 0.75rem;
    color: #ccc;
    border-top: 0.5em solid;
    border-right: 0.5em solid transparent;
    border-left: 0.5em solid transparent;
  }
  #sort-by .btn {
    width: 70%;
    padding: 0 0.625rem;
    height: 1.875rem;
    background-color: #fff;
  }
  #sort-by {
    position: relative;
    height: 40px;
    margin: 22px 0;
    text-align: left;
    display: flex;
    background-color: #e3e4e5;
    line-height: 40px;
    text-indent: 0.2rem;
  }

  #sort-by .sort {
    width: 28%;
    margin-right: 0.4rem;
  }
  .export-quatation {
    position: absolute;
    right:0;
    top:5px;
    background-color: #e62129;
    color:#fff;
    width:80px;
    height:30px;
    cursor: pointer;
    text-align: center;
    line-height: 30px;
    box-shadow: 2px 2px 1px #888888;
  }
  .search-box {
    position: absolute;
    top: 0;
  }
  .pageing .page-count,
  .select-page .page-count {
    color: #f00;
  }
  .select-page {
    font-size: 12px;
    text-align: start;
    border-right: #000 1px solid;
  }
  .goods-list {
    font-size: 12px;
    margin-top: 14px;
  }
  .goods-list .table-responsive {
    margin-bottom: 0;
  }
  .goods-list .table th span {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #ccc;
  }
  #content {
    background-color: #f5f5f5;
  }
  #content .table tbody th,
  #content .table tbody td {
    border-bottom: 1px dashed #000;
    border-top: 0;
    padding: 0;
    text-align: center;
    font-size: 0.75rem;
    height: 40px;
  }
  #content .table thead td,
  #content .table thead th {
    border: 0;
    padding: 0;
    height: 30px;
    line-height: 1.5;
    font-size: 0.875rem;
    font-weight: normal;
    background-color: #e3e4e5;
  }
  #content .table thead th {
    vertical-align: middle;
  }
  #content .table tr th:nth-child(1) {
    width: 70px;
  }
  #content .table tr th:nth-child(2) {
    width: 150px;
  }
  #content .table tr th:nth-child(3) {
    width: 70px;
  }
  #content .table tr th:nth-child(4) {
    width: 120px;
  }
  #content .table tr th:nth-child(5) {
    width: 110px;
  }
  #content .table tr th:nth-child(6) {
    width: 120px;
  }
  #content .table tr th:nth-child(7) {
    width: 50px;
  }
  #content .table tr th:nth-child(8) {
    width: 40px;
  }
  #content .table tr th:nth-child(9) {
    width: 75px;
  }
  #content .table tr th:nth-child(10) {
    width: 80px;
  }
  #content .table tr th:nth-child(11) {
    width: 65px;
  }
  #content .table tr th:nth-child(12) {
    width: 65px;
  }
  #content .table tr th:nth-child(13) {
    width: 125px;
  }
  #content .table tr th:nth-child(14) {
    width: 60px;
  }
  #content .cutdown,
  #content .add {
    width: 21px;
    height: 21px;
    display: inline-block;
    border: 1px solid #ccc;
    line-height: 19px;
  }
  #content .cutdown {
    border-right: 0;
  }
  #content .add {
    border-left: 0;
  }
  #content .num {
    width: 66px;
    outline: 0;
    text-align: center;
    height: 21px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
  #content img {
    max-width: 30px;
  }
   #footer{
     display: flex;
     align-items:center;
     background-color: #e3e4e5
   }
  #footer .select-page {
    flex: 50%;
  }
  #footer .page-display {
    flex: 70%;
    text-align: left;
    font-size: 12px;
    padding-left: 20px;
  }
  .page-display .data-now {
    font-weight: normal;
  }
  .page-display .data-count {
    color: #f00;
  }
  .page-display .fresh {
    color: blue;
  }
  .page-now{
    text-align: center;
    display: inline-block;
    height: 20px;
    width: 40px;
    background-color: #ffffff;
  }
</style>
